import { render, staticRenderFns } from "./OdemeEmri152Taslak.vue?vue&type=template&id=2f4ae468"
import script from "./OdemeEmri152Taslak.vue?vue&type=script&lang=ts"
export * from "./OdemeEmri152Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports